import React from 'react';
import '../Spinner.scss';

export const Spin = ({ width = '100px', height = '100px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      className="spin"
    >
      <style>margin: 0 auto; shape-rendering: auto; margin: 0 auto;</style>
      <g transform="translate(79,50)">
        <g transform="rotate(0)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="1"
            transform="scale(1.24892 1.24892)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.9090909090909091s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.9090909090909091s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(74.39635245210425,65.67858370621232)">
        <g transform="rotate(32.72727272727273)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.9090909090909091"
            transform="scale(1.29619 1.29619)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.8181818181818182s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.8181818181818182s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(62.047035377054705,76.37932786528103)">
        <g transform="rotate(65.45454545454545)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.8181818181818182"
            transform="scale(1.34347 1.34347)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.7272727272727273s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.7272727272727273s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(45.87286969007474,78.70482181454705)">
        <g transform="rotate(98.18181818181817)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.7272727272727273"
            transform="scale(1.39074 1.39074)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.6363636363636364s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.6363636363636364s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(31.009038715586737,71.9167376562735)">
        <g transform="rotate(130.9090909090909)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.6363636363636364"
            transform="scale(1.43801 1.43801)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.5454545454545454s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.5454545454545454s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(22.174703765179576,58.17024414840146)">
        <g transform="rotate(163.63636363636365)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.5454545454545454"
            transform="scale(1.48528 1.48528)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.45454545454545453s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.45454545454545453s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(22.174703765179572,41.82975585159855)">
        <g transform="rotate(196.36363636363635)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.45454545454545453"
            transform="scale(1.01256 1.01256)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.36363636363636365s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.36363636363636365s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(31.00903871558673,28.083262343726513)">
        <g transform="rotate(229.0909090909091)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.36363636363636365"
            transform="scale(1.05983 1.05983)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.2727272727272727s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.2727272727272727s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(45.87286969007473,21.29517818545295)">
        <g transform="rotate(261.8181818181818)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.2727272727272727"
            transform="scale(1.1071 1.1071)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.18181818181818182s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.18181818181818182s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(62.0470353770547,23.620672134718962)">
        <g transform="rotate(294.54545454545456)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.18181818181818182"
            transform="scale(1.15437 1.15437)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="-0.09090909090909091s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="-0.09090909090909091s"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(74.39635245210425,34.32141629378768)">
        <g transform="rotate(327.2727272727273)">
          <circle
            cx="0"
            cy="0"
            r="5"
            fill="#89B0AE"
            fillOpacity="0.09090909090909091"
            transform="scale(1.20165 1.20165)"
          >
            <animateTransform
              attributeName="transform"
              type="scale"
              begin="0s"
              values="1.52 1.52;1 1"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
            ></animateTransform>
            <animate
              attributeName="fillOpacity"
              keyTimes="0;1"
              dur="1s"
              repeatCount="indefinite"
              values="1;0"
              begin="0s"
            ></animate>
          </circle>
        </g>
      </g>
    </svg>
  );
};
